<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const authApiUrl = process.env.VUE_APP_AUTH_API_URL || 'https://materialesapi.strixsoft.com';
const apiUrl = `${authApiUrl}/api/auth`;
const authService = {
  async login(formRaw) {
    try {
      const form = { ...formRaw };
      
      const response = await axios.post(`${apiUrl}/login`, form, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return utilsService.setLogin(response.data.token);
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  }
};

export default authService;
</script>
